import Vue from 'vue'
import { Modal } from 'buefy'
import TransparencyDetail from './components/transparencyDetail.vue'
Vue.use(Modal)

const el = document.querySelector('#transparency-report')
if (el !== null) {
  const vm = new Vue({
    delimiters: ['[[', ']]'],
    data: {
      interacted: false
    },
    methods: {
      showDetails () {
        this.$buefy.modal.open({
          component: TransparencyDetail,
          customClass: 'transparency-modal',
          width: 600,
          trapFocus: true
        })
      }
    },
  })
  vm.$mount(el)
}
